import { a as attr, h as html, d as createRegisterFunction, f as defineVividComponent } from './vivid-element.js';
import { B as BaseProgress } from './base-progress.js';
import { D as DelegatesAria, d as delegateAria } from './delegates-aria.js';
import { c as classNames } from './class-names.js';
import { w as when } from './when.js';

const styles = ".base{height:6px;align-items:center;margin:0;outline:none}.base:not(.connotation-pacific).connotation-cta{--_connotation-color-primary: var(--vvd-progress-cta-primary, var(--vvd-color-cta-500));--_connotation-color-soft: var(--vvd-progress-cta-soft, var(--vvd-color-cta-100))}.base:not(.connotation-pacific).connotation-alert{--_connotation-color-primary: var(--vvd-progress-alert-primary, var(--vvd-color-alert-500));--_connotation-color-soft: var(--vvd-progress-alert-soft, var(--vvd-color-alert-100))}.base:not(.connotation-pacific).connotation-success{--_connotation-color-primary: var(--vvd-progress-success-primary, var(--vvd-color-success-500));--_connotation-color-soft: var(--vvd-progress-success-soft, var(--vvd-color-success-100))}.base:not(.connotation-pacific):not(.connotation-cta,.connotation-alert,.connotation-success){--_connotation-color-primary: var(--vvd-progress-accent-primary, var(--vvd-color-canvas-text));--_connotation-color-soft: var(--vvd-progress-accent-soft, var(--vvd-color-neutral-100))}.base:not(.connotation-pacific){--_appearance-color-text: var(--_connotation-color-contrast);--_appearance-color-fill: var(--_connotation-color-soft);--_appearance-color-outline: transparent}.base.connotation-pacific{--_connotation-color-primary: linear-gradient(to right, var(--vvd-color-information-200), var(--vvd-color-cta-600))}.progress{position:relative;display:flex;overflow:hidden;align-items:center;block-size:100%;inline-size:100%}.base:not(.connotation-pacific) .progress{background-color:var(--_appearance-color-fill)}.base.connotation-pacific .progress{background-color:var(--vvd-color-neutral-100)}.base:not(.shape-sharp) .progress{border-radius:4px}.indeterminate{display:flex;border-radius:inherit;background-color:var(--_connotation-color-primary);block-size:100%;inline-size:100%}.determinate{border-radius:inherit;background-color:var(--_connotation-color-primary);block-size:100%;transition:all .2s ease-in-out}.connotation-pacific .determinate{background-image:var(--_connotation-color-primary)}.reverse .determinate{position:absolute;right:0}.paused .determinate{background:var(--vvd-color-neutral-300)}.indicator-1{animation:indeterminate-1 2s infinite;inline-size:30%}.indicator-2{animation:indeterminate-2 2s infinite;inline-size:60%}.indicator-1,.indicator-2{position:absolute;animation-timing-function:cubic-bezier(.4,0,.6,1);background-color:var(--vvd-color-neutral-100);block-size:100%;opacity:0}.connotation-pacific .indicator-1,.connotation-pacific .indicator-2{background-image:var(--_connotation-color-primary)}.paused .indicator-1,.paused .indicator-2{animation-play-state:paused;background-color:var(--_connotation-color-primary)}.reverse .indicator-1,.reverse .indicator-2{animation-direction:reverse}@keyframes indeterminate-1{0%{opacity:1;transform:translate(-100%)}70%{opacity:1;transform:translate(300%)}70.01%{opacity:0}to{opacity:0;transform:translate(300%)}}@keyframes indeterminate-2{0%{opacity:0;transform:translate(-150%)}29.99%{opacity:0}30%{opacity:1;transform:translate(-150%)}to{opacity:1;transform:translate(166.66%)}}";

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
class Progress extends DelegatesAria(BaseProgress) {
  constructor() {
    super(...arguments);
    this.reverse = false;
  }
}
__decorateClass([
  attr()
], Progress.prototype, "shape");
__decorateClass([
  attr()
], Progress.prototype, "connotation");
__decorateClass([
  attr({ mode: "boolean" })
], Progress.prototype, "reverse");

const getClasses = ({ connotation, shape, reverse, paused }) => classNames(
  "base",
  [`connotation-${connotation}`, Boolean(connotation)],
  [`shape-${shape}`, Boolean(shape)],
  ["reverse", Boolean(reverse)],
  ["paused", Boolean(paused)]
);
function determinate() {
  return html` <span
		class="determinate"
		style="width: ${(x) => x.percentComplete}%"
	></span>`;
}
function indeterminate() {
  return html` <span class="indeterminate" name="indeterminate">
		<span class="indicator-1"></span>
		<span class="indicator-2"></span>
	</span>`;
}
const ProgressTemplate = html`<template>
	<div
		class="${getClasses}"
		${delegateAria({
  role: "progressbar",
  ariaValueNow: (x) => x.value,
  ariaValueMin: (x) => x.min,
  ariaValueMax: (x) => x.max
})}
	>
		<div class="progress">
			${when((x) => typeof x.value === "number", determinate())}
			${when((x) => typeof x.value !== "number", indeterminate())}
		</div>
	</div>
</template>`;

const progressDefinition = defineVividComponent(
  "progress",
  Progress,
  ProgressTemplate,
  [],
  {
    styles
  }
);
const registerProgress = createRegisterFunction(progressDefinition);

export { Progress as P, progressDefinition as p, registerProgress as r };
